/**
 * @description 请求接口的封装
 * @data 2024-10-28
 */
import request from '@/plugins/commonAxios'
const baseURL = '/front'

//查询文章列表
export function getArticleList(params) {
  return request({ url: baseURL + '/articleList', method: 'get', params })
}
//查询文章详情
export function getArticleDetails(query) {
  return request({ url: '/front/' + query, method: 'get', })
}

//获取全部科室
export function getDepartmentList(params) {
  return request({ url: baseURL + '/departmentList', method: 'get' })
}
//获取全部中心领导
export function getLeaderList(params) {
  return request({ url: baseURL + '/leaderList', method: 'get' })
}
//获取全部友情链接
export function getBlogrollList(params) {
  return request({ url: baseURL + '/blogrollList', method: 'get' })
}


//查询最新动态
export function getlatest(params) {
  return request({ url: baseURL + '/latest', method: 'get', params })
}

//查询轮播动态
export function getSlideList(params) {
  return request({ url: baseURL + '/slideShowList', method: 'get' })
}

//获取最新动态类目
export function getCategory(params) {
  return request({ url: baseURL + '/category', method: 'get' })
}

//查询key
export function getKey(params) {
  return request({ url: baseURL + '/getKey', method: 'get', params })
}

//获取首页轮播动态
export function slideShowList(params) {
  return request({ url: baseURL + '/slideShowList', method: 'get' })
}
//获取获取首页专题
export function getThemeList(params) {
  return request({ url: baseURL + '/themeList', method: 'get' })
}




